export default {
	"deviceManage": {
		"transfer": "transfer",
		"recycling": "recycle",
		"chooseDeviceNumber": "select device number",
		"deviceLibrary": "device library",
		"adminrole": "administrator",
		"platform": "platform",
		"useMan": "user",
		"stakeholders": "current stakeholders",
		"department": "department",
		"gpsTime": "last tracking time",
		"offlineTime": "offline time",
		"equipmentStatus": "device status",
		"dumpEnergy": "remaining battery",
		"lat": "track",
		"lng": "please select an address",
		"deviceInfo": "device information",
		"equipmentNo": "equipment number",
		"equipmentCode": "device barcode",
		"cityName": "city",
		"statusStartDt": "status start time",
		"duration": "duration",
		"routeNos": "current tracking document",
		"useHistory": "usage history",
		"type": "type",
		"addDeviceInfo": "add management device",
		"transferAdmin": "transfer to device maintain person",
		"transferTakeholders": "current device maintain person",
		"equipmentLocation": "device positioning",
		"importDevice": "import device",
		"tipsSelectManager": "please select current device maintain person",
		"tipsTransferSuccess": "the transfer was successful",
		"tipsCannotRecycle": "devices in an \"in use\" state cannot be recycled.",
		"tipsSelectRecycle": "please select an item to be recovered.",
		"tipsConfirmRecycle": "are you sure you want to recycle?"
	},
	"machine": {
		"mapMonitor": "map monitoring",
		"lastStateInfo": "Latest status information",
		"lastTime": "latest time",
		"machineState": "Operating status",
		"doorState": "door status",
		"conditioningState": "Air conditioning status",
		"engineState": "engine status",
		"speed": "speed",
		"altitude": "altitude",
		"bearing": "position"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/machine/machine.js